// extracted by mini-css-extract-plugin
module.exports = {"fitsContainer":"Fits_fitsContainer__1Wj--","fitsImgWrapper":"Fits_fitsImgWrapper__3JHls","fitsImg":"Fits_fitsImg__3DRvw"};